import policyOwnershipAndFraudStatement from './policyOwnershipAndFraudStatement';
import additionalQuestions from './additionalQuestions';
import coverageAndClasses from './coverageAndClasses';
import currentCoverage from './currentCoverage';
import ownersOfficers from './ownersOfficers';
import insured from './insured';
import locations from './locations';
import general from './general';
// config
import config from '../../../config';

// -----------------------------------------------------

export const FORM_STATE_VERSION = config.formStateVersion;
export const FORM_STATE_VERSION_KEY = 'form-state-version';

export default {
  additionalQuestions,
  coverageAndClasses,
  currentCoverage,
  ownersOfficers,
  insured,
  locations,
  policyOwnershipAndFraudStatement,
  general,
};
